
const angleNameSort = [
"全景（正面）",
"番号札",
"上部（正面）",
"中部（正面）",
"下部（正面）",
"上部（側面）",
"中部（側面）",
"下部（側面）",
"対象電柱+隣の電柱①",
"対象電柱+隣の電柱②",
"支線（金属部分）①"
];

export default {
  angleNameSort,
}